import { AdvancedFilters } from '@ps/survey-utils';
import {
  AdvancedFiltersLookupState,
  FeasibilityState,
  FlexibilityPricesState,
  InsightsState,
  ScoreState,
  SurveyCreationPricingState,
} from './survey-creation-insights-state.model';

export const INITIAL_SCORE_STATE: ScoreState = {
  scorePercentage: null,
  loading: false,
  error: null,
};

export const INITIAL_ADVANCED_FILTERS: AdvancedFilters = {
  type: 'exclude',
  dateRange: { start: null, end: null },
  criteria: [],
  manualGroups: [],
  respondentStatuses: [],
  excludeFromFeasibleAudience: false,
};

export const INITIAL_ADVANCED_FILTERS_LOOKUP_STATE: AdvancedFiltersLookupState =
  {
    criteriaSurveySummaries: [],
    respondentCount: 0,
    loading: false,
    error: null,
    criteriaSearchResults: [],
    groupSearchResults: [],
  };

export const INITIAL_FEASIBILITY_STATE: FeasibilityState = {
  total: 0,
  hasQuota: false,
  quotaGroups: [],
  audience: [],
  withExclusions: null,
  advancedFilters: { ...INITIAL_ADVANCED_FILTERS },
  advancedFiltersLookup: { ...INITIAL_ADVANCED_FILTERS_LOOKUP_STATE },
  cpi: 0,
  suppliers: [],
  loading: false,
  error: null,
};

export const INITIAL_FLEXIBILITY_PRICES_STATE: FlexibilityPricesState = {
  prices: null,
  error: null,
};

export const INITIAL_SURVEY_CREATION_PRICING_STATE: SurveyCreationPricingState =
  {
    offerPrice: null,
    surveyPauseThreshold: null,
    blendApplied: false,
  };

export const INITIAL_INSIGHTS_STATE: InsightsState = {
  score: { ...INITIAL_SCORE_STATE },
  feasibility: { ...INITIAL_FEASIBILITY_STATE },
  flexibilityPrices: { ...INITIAL_FLEXIBILITY_PRICES_STATE },
  pricing: { ...INITIAL_SURVEY_CREATION_PRICING_STATE },
};
